var _rect, _rect2, _rect3, _rect4, _path, _path2, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPaymentMethod(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 38,
    viewBox: "0 0 55 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.788116,
    y: 1.31839,
    width: 26.9674,
    height: 18.6099,
    rx: 1.33603,
    stroke: "#0C1C33",
    strokeWidth: 0.890686
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.27148,
    y: 5.51758,
    width: 26.0008,
    height: 3.71441,
    fill: "#0C1C33"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.12842,
    y: 14.801,
    width: 9.28601,
    height: 0.928601,
    fill: "#0C1C33"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.77148,
    y: 18.8606,
    width: 26.4386,
    height: 17.9476,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.4088 26.8918L40.913 26.8918L43.2976 24.5072C43.4947 24.3118 43.6055 24.0456 43.6055 23.7678C43.6055 23.4901 43.4947 23.2239 43.2976 23.0284C43.1025 22.8346 42.8385 22.7256 42.5635 22.7256C42.2883 22.7256 42.0245 22.8346 41.8292 23.0284L37.6639 27.1937C37.4668 27.3892 37.356 27.6554 37.356 27.9331C37.356 28.2109 37.4668 28.477 37.6639 28.6725L41.8292 32.8378C42.0233 33.0301 42.285 33.1386 42.5582 33.1398C42.835 33.1414 43.1011 33.0326 43.2976 32.8378C43.4947 32.6423 43.6055 32.3762 43.6055 32.0984C43.6055 31.8207 43.4947 31.5545 43.2976 31.359L40.913 28.9745L53.4088 28.9745C53.7808 28.9745 54.1245 28.776 54.3107 28.4538C54.4966 28.1316 54.4966 27.7346 54.3107 27.4125C54.1245 27.0903 53.7807 26.8918 53.4088 26.8918Z",
    fill: "#0C1C33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3033 27.5227V8.34644H38.7871",
    stroke: "#0C1C33",
    strokeWidth: 2.23549,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7.47708,
    y: 18.4886,
    width: 26.9674,
    height: 18.6099,
    rx: 1.33603,
    stroke: "#0C1C33",
    strokeWidth: 0.890686
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 13.25,
    y: 22.0513,
    width: 11.7676,
    height: 1.11465,
    transform: "rotate(90 13.25 22.0513)",
    fill: "#0C1C33"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1973,
    y: 22.0513,
    width: 11.7676,
    height: 1.00532,
    transform: "rotate(90 15.1973 22.0513)",
    fill: "#0C1C33"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 19.769,
    y: 22.0513,
    width: 11.7676,
    height: 2.31669,
    transform: "rotate(90 19.769 22.0513)",
    fill: "#0C1C33"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 25.6191,
    y: 22.0513,
    width: 11.7676,
    height: 2.31669,
    transform: "rotate(90 25.6191 22.0513)",
    fill: "#0C1C33"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 27.8496,
    y: 22.0513,
    width: 11.7676,
    height: 1.05333,
    transform: "rotate(90 27.8496 22.0513)",
    fill: "#0C1C33"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7637,
    y: 22.0513,
    width: 11.7676,
    height: 1.05333,
    transform: "rotate(90 21.7637 22.0513)",
    fill: "#0C1C33"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 29.8462,
    y: 22.0513,
    width: 11.7676,
    height: 1.05333,
    transform: "rotate(90 29.8462 22.0513)",
    fill: "#0C1C33"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPaymentMethod);
export default __webpack_public_path__ + "static/media/ic-payment-method.438050b8dfbe741a738a54efa51adf63.svg";
export { ForwardRef as ReactComponent };